import { Link, useLocation } from "react-router-dom"
import {Gem} from 'lucide-react'

function Header() {
  const location = useLocation()
  
  const isActive = (path: string) => location.pathname === path
  
  return (
    <header className="bg-white border-b border-emerald-100 sticky top-0 z-50 shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-12 h-12 bg-gradient-to-br from-emerald-600 to-blue-700 rounded-lg flex items-center justify-center transform group-hover:scale-105 transition-transform">
              <Gem className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">Gemstone Calculator</h1>
              <p className="text-xs text-gray-500">Professional Gem Analysis</p>
            </div>
          </Link>
          
          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive("/")
                  ? "bg-emerald-50 text-emerald-700"
                  : "text-gray-600 hover:bg-gray-50"
              }`}
            >
              Calculator
            </Link>
            <Link
              to="/emerald-calculator"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive("/emerald-calculator")
                  ? "bg-emerald-50 text-emerald-700"
                  : "text-gray-600 hover:bg-gray-50"
              }`}
            >
              Emerald
            </Link>
            <Link
              to="/sapphire-calculator"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive("/sapphire-calculator")
                  ? "bg-emerald-50 text-emerald-700"
                  : "text-gray-600 hover:bg-gray-50"
              }`}
            >
              Sapphire
            </Link>
            <Link
              to="/amethyst-calculator"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive("/amethyst-calculator")
                  ? "bg-emerald-50 text-emerald-700"
                  : "text-gray-600 hover:bg-gray-50"
              }`}
            >
              Amethyst
            </Link>
            <Link
              to="/opal-calculator"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive("/opal-calculator")
                  ? "bg-emerald-50 text-emerald-700"
                  : "text-gray-600 hover:bg-gray-50"
              }`}
            >
              Opal
            </Link>
            <Link
              to="/birthstone-calculator"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive("/birthstone-calculator")
                  ? "bg-emerald-50 text-emerald-700"
                  : "text-gray-600 hover:bg-gray-50"
              }`}
            >
              Birthstone
            </Link>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header
